import React from 'react'
export default (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
    width="539.83"
    height="220.632"
    viewBox="0 0 539.83 220.632"
  >
    <defs>
      <filter
        id="a"
        x="0"
        y="156.07"
        width="64.42"
        height="64.42"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="3" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="3" result="b" />
        <feFlood floodOpacity="0.4" />
        <feComposite operator="in" in2="b" />
        <feComposite in="SourceGraphic" />
      </filter>
      <filter
        id="c"
        x="49.063"
        y="155.93"
        width="64.408"
        height="64.441"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="3" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="3" result="d" />
        <feFlood floodOpacity="0.4" />
        <feComposite operator="in" in2="d" />
        <feComposite in="SourceGraphic" />
      </filter>
      <filter
        id="e"
        x="98.238"
        y="137.36"
        width="64.492"
        height="83.014"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="3" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="3" result="f" />
        <feFlood floodOpacity="0.4" />
        <feComposite operator="in" in2="f" />
        <feComposite in="SourceGraphic" />
      </filter>
      <filter
        id="g"
        x="147.929"
        y="155.97"
        width="45.911"
        height="64.44"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="3" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="3" result="h" />
        <feFlood floodOpacity="0.4" />
        <feComposite operator="in" in2="h" />
        <feComposite in="SourceGraphic" />
      </filter>
      <filter
        id="i"
        x="178.49"
        y="156.198"
        width="64.4"
        height="64.433"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="3" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="3" result="j" />
        <feFlood floodOpacity="0.4" />
        <feComposite operator="in" in2="j" />
        <feComposite in="SourceGraphic" />
      </filter>
      <filter
        id="k"
        x="277.52"
        y="156.198"
        width="64.4"
        height="64.433"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="3" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="3" result="l" />
        <feFlood floodOpacity="0.4" />
        <feComposite operator="in" in2="l" />
        <feComposite in="SourceGraphic" />
      </filter>
      <filter
        id="m"
        x="327.07"
        y="156.07"
        width="101.731"
        height="64.471"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="3" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="3" result="n" />
        <feFlood floodOpacity="0.4" />
        <feComposite operator="in" in2="n" />
        <feComposite in="SourceGraphic" />
      </filter>
      <filter
        id="o"
        x="413.968"
        y="155.92"
        width="64.422"
        height="64.451"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="3" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="3" result="p" />
        <feFlood floodOpacity="0.4" />
        <feComposite operator="in" in2="p" />
        <feComposite in="SourceGraphic" />
      </filter>
      <filter
        id="q"
        x="463.02"
        y="156.078"
        width="64.451"
        height="64.412"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="3" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="3" result="r" />
        <feFlood floodOpacity="0.4" />
        <feComposite operator="in" in2="r" />
        <feComposite in="SourceGraphic" />
      </filter>
      <filter
        id="s"
        x="512.73"
        y="155.97"
        width="27.1"
        height="64.42"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="3" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="3" result="t" />
        <feFlood floodOpacity="0.4" />
        <feComposite operator="in" in2="t" />
        <feComposite in="SourceGraphic" />
      </filter>
      <filter
        id="u"
        x="228"
        y="156.38"
        width="65.71"
        height="64"
        filterUnits="userSpaceOnUse"
      >
        <feOffset dy="3" input="SourceAlpha" />
        <feGaussianBlur stdDeviation="3" result="v" />
        <feFlood floodOpacity="0.4" />
        <feComposite operator="in" in2="v" />
        <feComposite in="SourceGraphic" />
      </filter>
      <clipPath id="w">
        <path
          d="M297.6,181.65a5.55,5.55,0,1,0,2.77-.74A5.55,5.55,0,0,0,297.6,181.65Z"
          fill="none"
        />
      </clipPath>
      <linearGradient
        id="x"
        x1="0.117"
        y1="0.5"
        x2="0.883"
        y2="0.5"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="#8b0e0f" />
        <stop offset="0.65" stopColor="#e52027" />
        <stop offset="1" stopColor="#e52027" />
      </linearGradient>
      <clipPath id="y">
        <path
          d="M199.1,181.65a5.54,5.54,0,1,0,2.76-.74A5.54,5.54,0,0,0,199.1,181.65Z"
          fill="none"
        />
      </clipPath>
      <linearGradient
        id="z"
        x1="0.116"
        y1="0.5"
        x2="0.882"
        y2="0.5"
        href="#x"
      />
      <clipPath id="aa">
        <path
          d="M355.17,97.8l.31-1.14,18.59,4.86c-.08.42-.16.84-.25,1.26ZM315.46,62.25l-5.58-2.62c2.27-1.86,3.3-5.11,6.61-3.47,3.6,1.78,7.33,3.49,10.47,5.93,4.63,3.61,10,5.93,14.73,9.54,6.61,5.06,15,7.75,22.64,11.51,1.68.83,3.23,1.92,5.51,3.28-1.29.24-1.55.37-1.71.3-6.67-3.14-13.38-6.21-20-9.49-2.66-1.31-5.21-1.8-6.4-.53,11.57,5,23.08,10.1,34.66,15,2.85,1.21,3.18,3,2.33,6.12-28.27-5.39-54.21-17.3-81.81-26.92,3.28-3,6-5.3,8.47-7.78,2.07-2,4-3.1,6.73-1,.79.62,2.09.57,3.16.83Zm-31.16,3a11.44,11.44,0,0,0-3.37-1.44c-4.88-1.76-9.77-3.49-14.84-5.3,9.24-4.88,18.18-9.6,27.14-14.27a2,2,0,0,1,1.61-.06c4.51,2.37,9,4.81,14.18,7.61-2.16,1.83-3.69,4-5.66,4.56s-4.36-.7-7.12-1.27l5.18,2.78c-3.05,2.5-5.76,4.43-8.12,6.72-1.62,1.56-3.2,2.41-4.83,2.41h0a6.67,6.67,0,0,1-4.17-1.73ZM309,40.9c-2.75-1.89-2.74-2.43,0-4.17,6.27-3.93,12.57-7.83,18.81-11.82,4.18-2.68,8.28-5.5,12.41-8.25.06.1-4.46,5.08-4.4,5.18C332,26,332.68,25.12,329,29.33c-3.11,3.5-5.82,7.36-9,10.79-2.44,2.64-3.65,3.89-5.1,3.89S312,42.93,309,40.9ZM147.76,101.52l18.59-4.86.3,1.14q-9.32,2.51-18.65,5ZM152,86.42c2.28-1.36,3.83-2.45,5.51-3.28,7.61-3.76,16-6.45,22.64-11.51,4.73-3.61,10.09-5.93,14.73-9.54,3.14-2.44,6.87-4.15,10.47-5.93,3.31-1.64,4.34,1.61,6.61,3.47l-5.59,2.62c.07.24.13.47.19.7,1.07-.26,2.37-.21,3.16-.83,2.7-2.1,4.66-1,6.72,1,2.51,2.48,5.19,4.78,8.48,7.78-27.6,9.62-53.54,21.53-81.81,26.92-.85-3.07-.52-4.91,2.33-6.12,11.58-4.9,23.09-10,34.66-15-1.19-1.27-3.75-.78-6.4.53-6.61,3.28-13.32,6.35-20,9.49h-.1A13.184,13.184,0,0,1,152,86.42Zm66.48-30.06c-2-.52-3.5-2.73-5.66-4.56C218,49,222.48,46.56,227,44.19a2,2,0,0,1,1.6.06c9,4.67,17.9,9.39,27.15,14.27-5.07,1.81-10,3.54-14.85,5.3a11.49,11.49,0,0,0-3.36,1.44c-3.28,2.64-6.07,2.16-9-.67-2.36-2.29-5.07-4.22-8.12-6.72l5.18-2.78c-2.3.47-4.35,1.39-6.1,1.39a4.31,4.31,0,0,1-1.03-.12Zm-16.6-16.24c-3.18-3.43-5.89-7.29-9-10.79-3.73-4.21-3.06-3.38-6.9-7.49.06-.1-4.46-5.08-4.4-5.18,4.13,2.75,8.23,5.57,12.41,8.25,6.24,4,12.53,7.89,18.81,11.82,2.78,1.74,2.79,2.28,0,4.17-3,2-4.51,3.11-5.86,3.11s-2.63-1.24-5.07-3.89Zm59,52,6,.6c-2.77,2.07-4.38,3.22-6,3.47-1.58-.25-3.19-1.4-6-3.47Zm-.35-26.05.35.06.35-.06L262,66l7.77,3-.26.75-6.91-1.79-.16.49,15.95,6.2c-5.35,2.79-9.84,5.2-14.4,7.48-1,.51-2.05,1-3.09,1.51-1-.48-2.05-1-3.08-1.51-4.56-2.28-9-4.69-14.4-7.48l15.95-6.2-.16-.49-6.92,1.79-.25-.75,7.77-3Zm.35-31.23c1.84.61,3.68,1.2,5.55,1.68,6,1.52,11.81,3.42,17.71,5.16l-.15,1c-2.14.94-4.22,2.43-6.44,2.67s-4.35-.85-6.29-1.3l2.74,3.2c-4.67,1.86-9,3.58-13.13,5.22-4.18-1.64-8.45-3.36-13.12-5.22l2.75-3.18c-1.94.45-4.19,1.53-6.29,1.3s-4.3-1.73-6.44-2.67l-.15-1c5.9-1.74,11.75-3.64,17.71-5.16,1.91-.47,3.75-1.06,5.58-1.67Zm-.35-7.08V28a28.25,28.25,0,0,1-4.47,1.16c-10.75,1.67-21.56,2.93-32.34,4.35-1.5.2-3.29,1-4.45.41q-10.45-5-20.66-10.51c-6.18-3.35-12.17-7-18.31-10.47a18.35,18.35,0,0,0-4.26-1.91l7.73,16.79c4.28,6,10.75,14.12,14.83,20.27a2.57,2.57,0,0,1-.34,2.46,15.2,15.2,0,0,1-4.15,2.81c-.67.31-1.74-.26-2.12-.33a30.282,30.282,0,0,1-4,4.08,58.8,58.8,0,0,1-7.41,4.44c-11.44,5.94-21.7,14-33.55,19.15-.11,0-.13.31-.2.49l1.87-.27a13.12,13.12,0,0,1-3.49,3c-.87.55-1.82,1.35-2.74,2h0A4.67,4.67,0,0,1,140,87l-5.83,2.64.08.1-.16-.06c-3.44,2.36-6.88,4.73-10.38,7-1.62,1.07-3.34,2-5,3l-9,3.64a3.93,3.93,0,0,1-2.52,2.68c-2.21,1-4,3-5.94,4.62.11.19.21.38.31.57l6-2.08.44.83-6.39,4.44c2.5-.44,4.47-.68,6.38-1.17.36-.09.71-.17,1-.23l18.07-4.23,9-2.17h0l7.84-1.86a4.921,4.921,0,0,1,1.1-.35c1.25-.24,2.5-.52,3.75-.8l2.29-.54c1.26-.31,2.51-.63,3.76-1,9.25-2.67,18.52-5.31,27.7-8.25,5.52-1.76,10.77-4.37,16.32-6,9.89-2.94,19.9-5.46,29.88-8.06a4.43,4.43,0,0,1,3.1.28c3.9,2.45,7.6,5.2,11.5,7.64,5.69,3.57,11.46,7,17.2,10.5l.35.21.35-.21c5.75-3.48,11.52-6.93,17.21-10.5,3.9-2.44,7.6-5.19,11.49-7.64a4.46,4.46,0,0,1,3.11-.28c10,2.6,20,5.12,29.88,8.06,5.55,1.64,10.8,4.25,16.32,6,9.18,2.94,18.45,5.58,27.7,8.25,1.24.36,2.5.68,3.76,1l2.29.54c1.25.28,2.5.56,3.75.8a4.92,4.92,0,0,1,1.1.35l7.83,1.86h0l9,2.17L412.73,113a9.762,9.762,0,0,1,1,.23c1.91.49,3.88.73,6.38,1.17l-6.34-4.4c.14-.28.29-.55.44-.83l6,2.08.3-.57c-2-1.58-3.72-3.59-5.93-4.62a3.93,3.93,0,0,1-2.52-2.68l-9-3.64c-1.66-1-3.38-1.91-5-3-3.49-2.3-6.93-4.67-10.37-7l-.16.06.08-.1-5.8-2.7a4.67,4.67,0,0,1-2.44-1.1h0c-.92-.65-1.87-1.45-2.74-2a13.16,13.16,0,0,1-3.5-3l1.87.27c-.06-.18-.08-.44-.19-.49-11.86-5.2-22.12-13.21-33.56-19.15a60.261,60.261,0,0,1-7.41-4.44,30.809,30.809,0,0,1-4-4.08c-.38.07-1.45.64-2.13.33a15.3,15.3,0,0,1-4.14-2.81,2.57,2.57,0,0,1-.34-2.46C327.28,42,333.75,33.86,338,27.85l7.73-16.79A18.35,18.35,0,0,0,341.5,13c-6.14,3.43-12.13,7.12-18.31,10.47Q313,29,302.52,34c-1.15.55-2.94-.21-4.44-.41-10.79-1.42-21.59-2.68-32.34-4.35A28.65,28.65,0,0,1,261.26,28v-.24l-.35.12Z"
          fill="none"
        />
      </clipPath>
      <linearGradient id="ab" x1="0.5" y1="0" x2="0.5" y2="1" href="#x" />
    </defs>
    <g transform="translate(9)">
      <g transform="matrix(1, 0, 0, 1, -9, 0)" filter="url(#a)">
        <path
          d="M45.48,162.07q-5.77,7.86-10.85,15.09-2.18,3.1-4.44,6.26t-4.35,6.1c-1.38,2-2.68,3.79-3.92,5.47s-2.28,3.12-3.11,4.29H46.42v9.21H.83q5.69-7.86,10.85-15.1,2.18-3.1,4.5-6.25c1.55-2.1,3-4.14,4.39-6.1s2.69-3.79,3.93-5.48,2.27-3.12,3.1-4.29H0v-9.2Z"
          transform="translate(9)"
          fill="#fff"
        />
      </g>
      <g transform="matrix(1, 0, 0, 1, -9, 0)" filter="url(#c)">
        <path
          d="M72.36,162a22.51,22.51,0,0,1,9,1.81,23.32,23.32,0,0,1,12.3,12.3,22.66,22.66,0,0,1,1.81,9v23.26H72.36a22.57,22.57,0,0,1-9-1.81,23.129,23.129,0,0,1-7.44-5,23.54,23.54,0,0,1-5-7.44,22.91,22.91,0,0,1,5-25.38,23.65,23.65,0,0,1,7.44-5,22.57,22.57,0,0,1,9-1.81m14,37.21V185.12a13.49,13.49,0,0,0-1.09-5.42,14,14,0,0,0-3-4.45,14.15,14.15,0,0,0-4.44-3,13.71,13.71,0,0,0-5.43-1.08,14,14,0,0,0-13,8.53,13.67,13.67,0,0,0-1.09,5.42,14.07,14.07,0,0,0,1.09,5.48,13.76,13.76,0,0,0,3,4.5,14,14,0,0,0,10,4.08Z"
          transform="translate(9)"
          fill="#fff"
        />
      </g>
      <g transform="matrix(1, 0, 0, 1, -9, 0)" filter="url(#e)">
        <path
          d="M144.73,143.36v41.76a22.82,22.82,0,0,1-1.81,9,23.91,23.91,0,0,1-5,7.44,23.13,23.13,0,0,1-25.37,5,23.38,23.38,0,0,1-12.46-12.45,22.94,22.94,0,0,1,5-25.38,23.81,23.81,0,0,1,7.45-5,22.57,22.57,0,0,1,9-1.81h14V143.36Zm-23.16,55.82A13.71,13.71,0,0,0,127,198.1a14.38,14.38,0,0,0,4.44-3,13.76,13.76,0,0,0,3-4.5,14.059,14.059,0,0,0,1.08-5.48v-14h-14a13.93,13.93,0,0,0-13,8.53,13.49,13.49,0,0,0-1.09,5.42,13.933,13.933,0,0,0,14.08,14.08Z"
          transform="translate(9)"
          fill="#fff"
        />
      </g>
      <g transform="matrix(1, 0, 0, 1, -9, 0)" filter="url(#g)">
        <path
          d="M175.84,162v9.2h-4.65a13.71,13.71,0,0,0-5.43,1.08,14.15,14.15,0,0,0-4.44,3,14,14,0,0,0-3,4.45,13.49,13.49,0,0,0-1.09,5.42v23.26h-9.3V185.12a22.49,22.49,0,0,1,1.81-9,22.81,22.81,0,0,1,5-7.34,23.76,23.76,0,0,1,7.44-5,22.65,22.65,0,0,1,9-1.81Z"
          transform="translate(9)"
          fill="#fff"
        />
      </g>
      <g transform="matrix(1, 0, 0, 1, -9, 0)" filter="url(#i)">
        <path
          d="M178.53,185.33a22.71,22.71,0,0,1,1.8-9.05A23.233,23.233,0,0,1,210.69,164a24,24,0,0,1,7.39,5,23.09,23.09,0,0,1,5,7.33,23.243,23.243,0,0,1-30.4,30.5,22.75,22.75,0,0,1-7.39-5,23.91,23.91,0,0,1-5-7.44,22.82,22.82,0,0,1-1.8-9m9.09,0a14.06,14.06,0,0,0,28.12,0,13.54,13.54,0,0,0-1.09-5.43,14.134,14.134,0,0,0-25.97,0,13.54,13.54,0,0,0-1.02,5.37Z"
          transform="translate(9)"
          fill="#fff"
        />
      </g>
      <g transform="matrix(1, 0, 0, 1, -9, 0)" filter="url(#k)">
        <path
          d="M277.56,185.33a22.71,22.71,0,0,1,1.8-9.05A23.233,23.233,0,0,1,309.72,164a24,24,0,0,1,7.39,5,23.09,23.09,0,0,1,5,7.33,23.243,23.243,0,0,1-30.4,30.5,22.75,22.75,0,0,1-7.39-5,23.91,23.91,0,0,1-5-7.44,22.821,22.821,0,0,1-1.8-9m9.09,0a14.04,14.04,0,1,0,28.08,0,13.709,13.709,0,0,0-1.08-5.43,14.151,14.151,0,0,0-3-4.44,13.86,13.86,0,0,0-4.5-3,14.32,14.32,0,0,0-11,0,14,14,0,0,0-7.49,7.44,13.54,13.54,0,0,0-.97,5.37Z"
          transform="translate(9)"
          fill="#fff"
        />
      </g>
      <g transform="matrix(1, 0, 0, 1, -9, 0)" filter="url(#m)">
        <path
          d="M410.8,162.07v23.16a22.73,22.73,0,0,1-1.8,9,23.67,23.67,0,0,1-12.41,12.46,23.061,23.061,0,0,1-27.65-7.56,23.38,23.38,0,0,1-8,6.87,22.39,22.39,0,0,1-10.6,2.54,22.74,22.74,0,0,1-9-1.81,23.45,23.45,0,0,1-12.46-12.46,22.57,22.57,0,0,1-1.81-9v-23.2h9.3v23.16a14.041,14.041,0,0,0,8.53,12.97,13.71,13.71,0,0,0,5.43,1.08,13.967,13.967,0,0,0,14.06-14.08V162.07h9.2v23.16a14,14,0,0,0,8.53,13,13.71,13.71,0,0,0,5.43,1.08A14,14,0,0,0,393,198.2a13.81,13.81,0,0,0,7.5-7.49,14.1,14.1,0,0,0,1.08-5.48V162.07Z"
          transform="translate(9)"
          fill="#fff"
        />
      </g>
      <g transform="matrix(1, 0, 0, 1, -9, 0)" filter="url(#o)">
        <path
          d="M437.27,162a22.46,22.46,0,0,1,9,1.81,23.38,23.38,0,0,1,12.31,12.3,22.66,22.66,0,0,1,1.81,9v23.26H437.27a22.65,22.65,0,0,1-9-1.81,23.41,23.41,0,0,1-12.45-12.45,22.94,22.94,0,0,1,5-25.38,23.881,23.881,0,0,1,7.44-5,22.65,22.65,0,0,1,9-1.81m14,37.21V185.12a13.661,13.661,0,0,0-1.08-5.42,14,14,0,0,0-7.45-7.45,13.66,13.66,0,0,0-5.42-1.08,14.06,14.06,0,0,0-10,4.08,14.31,14.31,0,0,0-3,4.45,13.659,13.659,0,0,0-1.08,5.42,14,14,0,0,0,14.06,14.06Z"
          transform="translate(9)"
          fill="#fff"
        />
      </g>
      <g transform="matrix(1, 0, 0, 1, -9, 0)" filter="url(#q)">
        <path
          d="M464.92,176.18a23.2,23.2,0,0,1,30.35-12.3,24.059,24.059,0,0,1,7.39,5,23,23,0,0,1,5,7.34,22.68,22.68,0,0,1,1.81,9v23.26h-9.2V185.23a13.54,13.54,0,0,0-1.09-5.43,14,14,0,0,0-13-8.53,13.51,13.51,0,0,0-5.43,1.09,14,14,0,0,0-7.44,7.44,13.54,13.54,0,0,0-1.09,5.43v23.26h-9.2V185.23a22.68,22.68,0,0,1,1.81-9"
          transform="translate(9)"
          fill="#fff"
        />
      </g>
      <g transform="matrix(1, 0, 0, 1, -9, 0)" filter="url(#s)">
        <rect
          width="9.1"
          height="46.42"
          transform="translate(521.73 161.97)"
          fill="#fff"
        />
      </g>
      <g transform="matrix(1, 0, 0, 1, -9, 0)" filter="url(#u)">
        <path
          d="M228,208.38l23.91-46,23.8,46H265.53q-1.42-2.76-3.27-6.28c-1.23-2.35-2.45-4.73-3.68-7.15s-2.43-4.75-3.62-7-2.2-4.19-3-5.82l-3.53,6.79c-1.33,2.56-2.64,5.09-3.93,7.61s-2.49,4.85-3.58,7-1.94,3.76-2.55,4.85Z"
          transform="translate(9)"
          fill="#fff"
        />
      </g>
      <g clipPath="url(#w)">
        <rect
          width="12.66"
          height="11.87"
          transform="translate(294.04 180.91)"
          fill="url(#x)"
        />
      </g>
      <g clipPath="url(#y)">
        <rect
          width="12.66"
          height="11.87"
          transform="translate(195.54 180.91)"
          fill="url(#z)"
        />
      </g>
      <g clipPath="url(#aa)">
        <rect
          width="319.26"
          height="103.35"
          transform="translate(101.28 11.06)"
          fill="url(#ab)"
        />
      </g>
      <path
        d="M165.25,19.59c2.09-1.2,4.19-2.48,6.29-3.57a14.72,14.72,0,0,1,2.84-.88,3.412,3.412,0,0,1-.1.54l-9,4.37A1.411,1.411,0,0,1,165.25,19.59Zm12.8-7.13L190.9,5.07a2.677,2.677,0,0,0,.07.27c-.94.7-1.87,1.42-2.81,2.11-1.13.84-2.3,1.61-3.43,2.48a10.39,10.39,0,0,1-6.3,2.54Zm18.7-11.15C194,2.55,191.25,3.63,188.5,5c-3,1.44-6,3.07-9,4.67a10.66,10.66,0,0,0-1.81,1.3,4,4,0,0,1-2.6,1.24,8.48,8.48,0,0,1-.86.41c-.19.14-.37.3-.57.43l-.34.2a12,12,0,0,1-2.54,1.7,18.151,18.151,0,0,1-2.14.93l-15.86,9.44v.41a9.478,9.478,0,0,0,1-.24c1.45-.49,2.93-1.11,4.34-1.48a60.8,60.8,0,0,0,12.34-4.79c3.34-1.69,6.7-3.77,10-5a1.73,1.73,0,0,0,.51-.35,11.28,11.28,0,0,1,1.65-1.45c.67-.36,1.4-.22,2-.64,3.83-2.65,7.62-5.39,11.43-8.1a.316.316,0,0,1,.08-.21l-1.42.78,4.47-4L199.09,0a22.1,22.1,0,0,1-2.34,1.31Z"
        fill="#8b0e0f"
        fillRule="evenodd"
      />
      <path
        d="M348.05,15.68a3.414,3.414,0,0,0-.1-.54,14.939,14.939,0,0,1,2.84.88c2.09,1.09,4.19,2.37,6.29,3.57v.46ZM337.59,9.93c-1.12-.87-2.29-1.64-3.43-2.48-.94-.69-1.87-1.41-2.8-2.11a2.681,2.681,0,0,1,.07-.27l12.85,7.39h-.39a10.42,10.42,0,0,1-6.3-2.53ZM323.14.24l4.48,4-1.42-.78a.73.73,0,0,0,.07.21c3.81,2.71,7.61,5.45,11.44,8.1.61.42,1.34.28,2,.64a11.283,11.283,0,0,1,1.65,1.45,1.57,1.57,0,0,0,.5.35c3.33,1.22,6.69,3.3,10,5A60.5,60.5,0,0,0,364.24,24c1.41.37,2.9,1,4.35,1.48a8.9,8.9,0,0,0,1,.24v-.41l-15.86-9.44a18.313,18.313,0,0,1-2.15-.93,12.16,12.16,0,0,1-2.53-1.7c-.12-.07-.24-.13-.34-.2s-.39-.29-.58-.43-.58-.26-.86-.41a4,4,0,0,1-2.59-1.24,11.071,11.071,0,0,0-1.81-1.3c-3-1.6-6-3.23-9-4.67-2.76-1.33-5.5-2.41-8.26-3.65A23.3,23.3,0,0,1,323.23,0Z"
        fill="#8b0e0f"
        fillRule="evenodd"
      />
      <path
        d="M406.92,119.51c2.1-1.2,4.2-2.48,6.29-3.57a14.811,14.811,0,0,1,2.85-.88,3.449,3.449,0,0,1-.11.54l-9,4.37Zm12.8-7.13L432.58,105l.06.27c-.93.7-1.86,1.42-2.8,2.11-1.14.84-2.3,1.61-3.43,2.48a10.39,10.39,0,0,1-6.29,2.54Zm18.71-11.15c-2.76,1.24-5.5,2.32-8.26,3.65-3,1.44-6,3.07-9,4.67a10.279,10.279,0,0,0-1.81,1.3,4,4,0,0,1-2.6,1.24,6.726,6.726,0,0,1-.86.4c-.19.15-.37.31-.57.44l-.35.2a11.659,11.659,0,0,1-2.53,1.7,18.307,18.307,0,0,1-2.15.93l-15.86,9.44v.41c.33-.08.66-.13,1-.24,1.44-.49,2.93-1.11,4.34-1.48a60.5,60.5,0,0,0,12.33-4.79c3.34-1.69,6.71-3.77,10-5a1.75,1.75,0,0,0,.5-.35,11.32,11.32,0,0,1,1.66-1.45c.67-.36,1.4-.22,2-.64,3.82-2.65,7.62-5.39,11.43-8.11a.324.324,0,0,1,.07-.2l-1.42.78,4.48-4-.09-.24A20.022,20.022,0,0,1,438.43,101.23Z"
        fill="#e52027"
        fillRule="evenodd"
      />
      <path
        d="M106.19,115.6a2.59,2.59,0,0,0-.11-.54,14.81,14.81,0,0,1,2.85.88c2.09,1.09,4.19,2.37,6.29,3.57V120Zm-10.46-5.75c-1.13-.87-2.29-1.64-3.43-2.48-.94-.69-1.87-1.41-2.8-2.11l.06-.27,12.85,7.39H102a10.39,10.39,0,0,1-6.27-2.53Zm-14.45-9.69,4.48,4c-.71-.38-1.06-.58-1.42-.78,0,.07,0,.18.07.2,3.81,2.72,7.61,5.46,11.43,8.11.62.42,1.35.28,2,.64a11.32,11.32,0,0,1,1.66,1.45,1.75,1.75,0,0,0,.5.35c3.32,1.22,6.68,3.3,10,5a60.5,60.5,0,0,0,12.33,4.79c1.41.37,2.9,1,4.34,1.48.34.11.66.16,1,.24v-.41l-15.86-9.44a18.9,18.9,0,0,1-2.14-.93,11.66,11.66,0,0,1-2.53-1.7l-.35-.2c-.2-.13-.38-.29-.57-.44a6.722,6.722,0,0,1-.86-.4,4,4,0,0,1-2.6-1.24,10.28,10.28,0,0,0-1.81-1.3c-3-1.6-6-3.23-9-4.67-2.76-1.33-5.5-2.41-8.26-3.65-.77-.35-1.56-.87-2.34-1.31Z"
        fill="#e52027"
        fillRule="evenodd"
      />
    </g>
  </svg>
)
